module.exports = "<router-outlet></router-outlet>\r\n\r\n\r\n<ng-container *ngIf=\"ui.getLoaderState()\">\r\n    <div class=\"an-loader-container\" style=\"display:flex;z-index:2000;\">\r\n        <img src=\"../assets/loader.gif\" alt=\"\">\r\n    </div>\r\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main